import React, { memo, Ref } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  text?: string
  className?: any
  textColor?: string
  textClassName?: any
  /** Optional leading icon rendered before the label. */
  icon?: React.ReactNode
  /** When set, label renders as `span` (for overflow measurement / truncation). */
  textRef?: Ref<HTMLElement>
}

const ChipComponent = ({
  text,
  className,
  textColor = 'black',
  textClassName,
  icon,
  textRef,
}: Props) => (
  <div
    css={[
      tw`px-2 py-0.5 rounded-[10px] bg-[#EDEDED]`,
      icon && tw`inline-flex items-center gap-1`,
      className,
    ]}
  >
    {icon}
    <Typography
      ref={textRef}
      component={textRef ? 'span' : 'p'}
      color={textColor}
      variant="subtitle2"
      css={textClassName}
    >
      {text}
    </Typography>
  </div>
)

export const Chip = memo(ChipComponent)
